export default {
    en: {
        userProfile: 'User Profile',
        editInformation: 'Edit Information',
        detailInformation: 'Detailed information',
        account: 'Account',
        role: 'Role',
        department: 'Department',
        mob: 'Mob',
        founder: 'Founder',
        creationTime: 'Creation time',
        updater: 'Updater',
        updateTime: 'Update time',
        cancel: 'Cancel',
        confirm: 'Confirm',
        name: 'Name',
        email: 'Email',
        initialpassword: 'Initial password',
        confirmpassword: 'Confirm password',
        addSuccessfully: 'Added Successfully',
        editSuccessfully: 'Edited Successfully',
        openSuccessfully: 'Opened Successfully',
        ClosedSuccessfully: 'Closed Successfully',
        input: 'Input',
        select: 'Select',
        selectAccount: 'Please enter account',
        selectName: 'Please enter name',
        selectRole: 'Please select role',
        selectdepartment: 'Please select department',
        selectIphone: 'Please enter phone number',
        selectFormat: 'Please enter phone number in correct format',
        selectPassword: 'Please enter password',
        againPassword: 'Please enter password again',
        InconsistentPasswords: 'These two passwords do not match',
        emailAdress: 'Please enter email address',
        correctAddress: 'Please enter the correct email address',
        charType: 'The password should be at least 8 characters, consisting of uppercase letters, lowercase letters, special characters, and digits',
        phoneLengthError: 'The length of phone number should be at least 3 digits',
        device: 'Device',
        share: 'Shared Users'
    },
    zh: {
        userProfile: '用户信息',
        editInformation: '编辑信息',
        detailInformation: '详情信息',
        account: '账户',
        role: '角色',
        department: '部门',
        mob: '电话',
        founder: '创建人',
        creationTime: '创建时间',
        updater: '更新人',
        updateTime: '更新时间',
        cancel: '取消',
        confirm: '确定',
        name: '名称',
        email: '邮箱',
        initialpassword: '初始密码',
        confirmpassword: '确认密码',
        addSuccessfully: '添加成功',
        editSuccessfully: '编辑成功',
        openSuccessfully: '开启成功',
        ClosedSuccessfully: '关闭成功',
        input: '请输入',
        select: '请选择',
        selectAccount: '请输入账户',
        selectName: '请输入名称',
        selectRole: '请选择角色',
        selectdepartment: '请选择部门',
        selectIphone: '请输入手机号',
        selectFormat: '请输入正确的号码格式',
        selectPassword: '请输入密码',
        againPassword: '请再次输入密码',
        InconsistentPasswords: '两次密码不一致',
        emailAdress: '请输入邮箱地址',
        correctAddress: '请输入正确的邮箱地址',
        charType: '密码应该由至少8位大写字母，小写字母，特殊字符和数字组成',
        phoneLengthError: '号码长度至少3位',
        device: '设备',
        share: '共享用户'
    },
};
